import { guid } from "@libs/common/guid";
import { useMutation } from "react-query";

import { TtmFormsRefreshOptions } from "./ttm-forms-ops-gateway.dtos";
import { useGateways } from "@libs/api/gateways-context";
import { useFeedbackContext } from "../../../../stores/feedback-context/feedback-context";

export const usePostTtmFormsRefresh = (tenantId: guid) => {
  const { ttmFormsOpsGateway } = useGateways();
  const { success, error } = useFeedbackContext();

  return useMutation<string, Error, TtmFormsRefreshOptions>(
    (options: TtmFormsRefreshOptions) =>
      ttmFormsOpsGateway.requestRefresh(tenantId, options),
    {
      onSuccess: () => {
        success("Forms design refresh has been initiated.");
      },
      onError: e => {
        error(e.message);
      }
    }
  );
};
